/**
 * Falling Leaves Animation
 * v1.7.0
 * 
 * MIT License
 * 
 * Copyright (c) 2023 [Your Name or Organization]
 * 
 */

(function() {
    'use strict';
  
    // Configuration
    const CONFIG = {
      leafCount: 30,
      leafImageUrl: 'http://www.clipartqueen.com/image-files/red-lobed-fall-clipart-leaf.png',
      minSize: 20,
      maxSize: 70,
      minDuration: 10000,
      maxDuration: 20000,
      spawnInterval: 500 // New leaf every 500ms
    };
  
    // Create container
    const container = document.createElement('div');
    container.id = 'leaves-container';
    container.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;pointer-events:none;z-index:9999;';
    document.body.appendChild(container);
  
    // Create style
    const style = document.createElement('style');
    style.textContent = `
      .leaf {
        position: absolute;
        background-image: url('${CONFIG.leafImageUrl}');
        background-size: contain;
        background-repeat: no-repeat;
        opacity: 0.7;
      }
    `;
    document.head.appendChild(style);
  
    function random(min, max) {
      return Math.random() * (max - min) + min;
    }
  
    function createLeaf() {
      const leaf = document.createElement('div');
      leaf.className = 'leaf';
      leaf.style.left = `${random(0, 100)}vw`;
      leaf.style.top = '-5vh';
      leaf.style.opacity = random(0.5, 1);
      
      const size = random(CONFIG.minSize, CONFIG.maxSize);
      leaf.style.width = `${size}px`;
      leaf.style.height = `${size}px`;
  
      const initialRotation = random(0, 360);
      const rotationDirection = Math.random() < 0.5 ? 1 : -1;
      const rotationAmount = random(180, 540);
      const duration = random(CONFIG.minDuration, CONFIG.maxDuration);
      const horizontalMovement = random(-150, 150);
  
      const keyframes = [
        { transform: `translateX(0) translateY(0) rotate(${initialRotation}deg)`, offset: 0 },
        { transform: `translateX(${horizontalMovement * 0.3}px) translateY(30vh) rotate(${initialRotation + rotationAmount * 0.3 * rotationDirection}deg)`, offset: 0.3 },
        { transform: `translateX(${horizontalMovement * 0.5}px) translateY(50vh) rotate(${initialRotation + rotationAmount * 0.5 * rotationDirection}deg)`, offset: 0.5 },
        { transform: `translateX(${horizontalMovement * 0.7}px) translateY(70vh) rotate(${initialRotation + rotationAmount * 0.7 * rotationDirection}deg)`, offset: 0.7 },
        { transform: `translateX(${horizontalMovement}px) translateY(105vh) rotate(${initialRotation + rotationAmount * rotationDirection}deg)`, offset: 1 }
      ];
  
      leaf.animate(keyframes, {
        duration: duration,
        iterations: Infinity,
        easing: 'ease-in-out'
      });
  
      container.appendChild(leaf);
  
      setTimeout(() => {
        leaf.remove();
        createLeaf();
      }, duration);
    }
  
    function initLeaves() {
      let leavesCreated = 0;
      function spawnLeaf() {
        if (leavesCreated < CONFIG.leafCount) {
          createLeaf();
          leavesCreated++;
          setTimeout(spawnLeaf, CONFIG.spawnInterval);
        }
      }
      spawnLeaf();
    }
  
    // Initialize on load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initLeaves);
    } else {
      initLeaves();
    }
  })();